import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    collections: string;
    createCollection: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the Collections link in the ProjectTree */
            collections: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AllCollections.collections?c=p6mgkzox4f1w", defaultMessage: "Collections" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip and aria-label for creating a collection */
            createCollection: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AllCollections.createCollection?c=3s1e90rdyp5qt", defaultMessage: "New Collection" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
